
import styles from './Tile.module.scss'
import React from "react";
import {Article} from "@/types/Article.d";
import {relativeRoute} from "@/helpers/relativeRoute";
import Mensenlinq from "@/Atoms/Icons/Mensenlinq";

// interface TileProps extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
//     person: Person
// }

export default function Tile({article}: {article: Article}) {


    return <article className={`${styles.tile} `}>

        <a className={styles.article} href={relativeRoute('article', {slug: article.slug})} data-testid={`article-${article.slug}`}>

            {article.image ? <div className={styles.header}>
                <img src={article.image} alt={article.title} style={{objectPosition: article.image_focal}}/>
            </div> : <div className={[styles.header, styles.headerNoImage].join(' ')}>
                <Mensenlinq className={styles.shape}/>
            </div>}



                <div className={styles.content}>
            <h2>{article.title}</h2>
            <div dangerouslySetInnerHTML={{__html: article.content}}></div>
        </div>
        </a>

      <div className={styles.tags}>
        {article.tags.map((tag: any) => <a key={tag.slug} href={relativeRoute('article', {slug: article.slug})} className={styles.tag}>{tag.title}</a>)}
      </div>

    </article>
}
